/**
 * User role.
 * All clients have an `admin` role and optionally any other number of roles with any string.
 */
const ADMIN_ROLE = "admin";
type UserRole = typeof ADMIN_ROLE | string;

interface User {
  id: number;
  createdAt: string;
  email: string;
  name: string;
  likedFeedPosts: Array<string>;
  plan?: {
    id: number;
    createdAt: string;
    name?: string;
    updatedAt: string;
    userId?: number;
  };
  preferences: Array<string>;
  thumbnailUrl: string;
  updatedAt: string;
  profileThumbnail?: string;
  firstName?: string;
  roles: UserRole[];
  otpRequiredForLogin: boolean;
}

export type { User, UserRole };
export { ADMIN_ROLE };
